<template>
  <main class="main" role="main">
    <div class="main__inner" v-if="$Util.isEmpty(researchData)"><!-- 배경: bg-->
      <div class="main__con">
        <div class="line"></div>
        <div class="main__con__ttl">
          <div class="box__con__route_name type_02"> <!--세로정렬-->
            <span class="academy">연구소 진행 현황</span>
            <span class="route">{{ userData.companyName }}</span>
          </div>
          <div class="small_notice">
            <div class="txt" style="margin: 0 auto;">
              <p><span style="font-size: 1.4rem;">현재 연구 과제를 등록 중입니다.</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main__inner" v-else><!-- 배경: bg-->
      <div class="main__con">
        <div class="small_notice">
          <div class="txt" style="margin: 0 auto;">
            <p>
              <span style="font-size: 1.4rem;">{{ researchData.year }} 연구 과제</span>
            </p>
          </div>
        </div>
        <div class="main__con__ttl">
          <div class="box__con__route_name type_02"> <!--세로정렬-->
            <span class="academy" style="text-align: center;">{{ researchData.subject }}</span>
            <div class="lab-info">
              <span class="route">{{ labInfo.labName }}</span>
              <span class="route">인정번호 : {{ labInfo.labId }}</span>
            </div>
          </div>
        </div>

        <div class="small_notice">
          <div class="txt" style="margin: 0 auto;">
            <p><span style="font-size: 1.4rem;">연구원 및 보조원 인적사항</span></p>
          </div>
        </div>
        <div class="mypage__page">
          <ul class="mypage__page__ul">
            <li class="mypage__page__li" v-for="(item, index) in researchMemberList" :key="index">
              <div>
                {{ item.name }} ∙ {{ item.age }}세 ∙ {{ item.level }} ∙ {{ item.gender }}
              </div>
              <div>
                {{ item.position }}
              </div>
            </li>
          </ul>
        </div>
        <div class="small_notice">
          <div class="txt" style="margin: 0 auto;">
            <p><span style="font-size: 1.4rem;">연구소 서비스</span></p>
          </div>
        </div>
        <div class="mypage__page">
          <ul class="mypage__page__ul">
            <li class="mypage__page__li" @click="$router.push('/lab/researchList').catch(() => {})">
              과거 연구일지 조회
              <i data-v-ef50f1be="" class="i_right_gr50"></i>
            </li>
            <li class="mypage__page__li" @click="$router.push(`/lab/requestChange?labNo=${labInfo.labNo}`).catch(() => {})">
              변경 신청
              <i data-v-ef50f1be="" class="i_right_gr50"></i></li>
            <li class="mypage__page__li" @click="$router.push(`/lab/requestPerformance?labNo=${labInfo.labNo}`).catch(() => {})">
              실적보고 신청
              <i data-v-ef50f1be="" class="i_right_gr50"></i>
            </li>
          </ul>
        </div>
      </div>
      <div class="small_notice inquire">
        <p class="complete__txt__small" style="margin-top: 0; margin: 0 auto;">
          문의사항은 문의하기를 이용해주세요.
        </p>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      labInfo: {},
      researchData: {},
      researchMemberList: [],
      params: {
        userNo: this.$store.getters['account/getUserData'].userNo
      }
    };
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    }
  },
  created: function () {
    this.getLatestLabResearchData();
  },
  methods: {
    getLatestLabResearchData: async function () {
      const res = await this.$LabSvc.getLatestLabResearchData(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.labInfo = entity.labInfo
        this.researchData = entity.researchData
        this.researchMemberList = entity.researchMemberList
      }

    }
  }
};
</script>
<style lang="scss" scoped>
.box__con__route_name.type_02 {
  text-align: center;
  margin-bottom: 1.5rem;
}

.lab-info {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}
</style>
